import { Card } from "primereact/card";
import { useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { TREE_NODE_FRAGMENT } from "./content-card.graphql";
import { type ContentCardProps } from "./content-card.types";
import { BaseContentEditor } from "../BaseContentEditor";
import { ELearningContentEditor } from "../elearning-content-editor";

export const ContentCard = ({ treeNodeFragmentRef }: ContentCardProps) => {
	const { t } = useTranslation("common");
	const node = useFragment(TREE_NODE_FRAGMENT, treeNodeFragmentRef);

	return (
		<Card className="mb-2">
			{(() => {
				switch (node.typeDefinition.definitionType) {
					case "branch":
						return (
							<BaseContentEditor>
								<p>{t("educationalOffer.cannotHaveElements")}</p>
							</BaseContentEditor>
						);
					case "content":
						switch (node.typeDefinition.contentKind) {
							case "ELearning":
								return <ELearningContentEditor treeNodeFragmentRef={node} />;
							default:
								return null;
						}
					default:
						return null;
				}
			})()}
		</Card>
	);
};
